import React from 'react';
import { UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { IOption } from '../ExternalDashboardSensei/types';

export enum TicketStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  CLOSED = 'CLOSED',
  FORCE_CLOSED = 'FORCE_CLOSED'
}

export enum TicketAcitvityType {
  COMMENT_ADDITION = 'COMMENT_ADDITION',
  TICKET_CREATION = 'TICKET_CREATION'
}

export interface IActivity {
  type: string;
  activityBy: {
    referenceId: string;
    name: string;
  };
  activityAt: number;
  value: string;
}

export interface ICustomerDetails {
  customerReferenceId: string;
  customerName: string;
  currentDpd: string;
  outstandingAmount: number;
}

export interface ITicket {
  referenceId: string;
  loanAccountNumber: string;
  status: TicketStatus;
  isAcknowledgedByAssignee: boolean;
  newUpdatesCount: number;
  requestTypeLabel: string;
  details: {
    category: string;
    title: string;
  };
  createdAt: number;
  requestedBy: {
    referenceId: string;
    name: string;
  };
  activityLogs: IActivity[];
  customerDetails: ICustomerDetails;
  supportRequestDetails: {
    address: string;
    caseReferenceId: string;
    businessVertical: string;
  };
}

export interface IActivityLog {
  ticket: ITicket;
  loading: boolean;
}

export interface ITicketTimeline {
  activity: IActivity;
}

export interface ICreateTicketDrawer {
  toggleDrawer: () => void;
  isOpen: boolean;
}

export interface ICustomerDetailValue {
  children: React.ReactNode;
  loading: boolean;
  hideTicketStatus: boolean;
  containerClass?: string;
}

export interface ICustomerDetail {
  ticket: ITicket;
  loading: boolean;
  hideTicketStatus?: boolean;
  containerClass?: string;
}

export interface IDrawerHeader {
  icon: React.ReactNode;
  title: string;
  subTitle: string;
  loading?: boolean;
}

export interface INoTicketsFound {
  toggleRequestFormDrawer: () => void;
}

export interface ISingleTicketDrawer {
  toggleDrawer: () => void;
  isOpen: boolean;
  ticket: ITicket;
  isLoading: boolean;
}

export interface ITicketForm {
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  watch: UseFormWatch<any>;
  register: UseFormRegister<any>;
  errors: any;
  commentValidation?: {
    required: string;
  };
}

export interface IRequestTicket {
  ticket: ITicket;
  showDashedLine: boolean;
  toggleTicketDrawer: () => void;
  isReceivedTicket?: boolean;
}

export interface IRequestTitle {
  title: string;
  icon: React.ReactNode;
}

export interface ICsaTicketing {
  requestRaised: {
    tickets: ITicket[];
    isLoading: boolean;
  };
  requestReceived: {
    tickets: ITicket[];
    isLoading: boolean;
  };
  ticket: {
    ticketDetails: ITicket;
    isLoading: boolean;
  };
}

export interface IFormData {
  requestTypes: IOption[];
  subTitle: string;
}

export interface ICommentWidget {
  ticket: ITicket;
}
